import { DxDataGridComponent, DxDiagramComponent, DxListComponent, DxScrollViewComponent, DxSelectBoxComponent, DxTreeViewComponent, DxDropDownBoxComponent, 
  DxFileUploaderComponent} from 'devextreme-angular';
import { IoConfigurationComponent } from '../io-configuration/io-configuration.component';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewContainerRef } from '@angular/core';
import { SystemComponentService } from 'src/app/services/system-component.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { DeltaworldService } from 'src/app/services/deltaworld.service';
import { EstimateService } from 'src/app/services/estimate.service';
import { UtilityService } from 'src/app/services/utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
import { ToastService } from 'ng-uikit-pro-standard';
import ArrayStore from 'devextreme/data/array_store';
import DataGrid from "devextreme/ui/data_grid";
import { ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from 'src/app/app-config.service.service';
import { UserService } from 'src/app/services/user.service';
import { LoadingService } from 'src/app/services/loading.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'ai-estimate',
  templateUrl: './ai-estimate.component.html',
  styleUrls: ['./ai-estimate.component.scss']
})
export class AIestimateComponent implements OnInit {

  @ViewChild(DxTreeViewComponent, { static: false }) treeView;
  @ViewChild('fileUploader', { static: true }) fileUploader: DxFileUploaderComponent;
  @ViewChild("searchEstimate", { static: false }) searchEstimate: DxSelectBoxComponent;
  @ViewChild("searchEstimateDefault", { static: false }) searchEstimateDefault: DxSelectBoxComponent;


  @ViewChild(DxTreeViewComponent, { static: false }) treeView2;
  // @ViewChild(DxTreeViewComponent, { static: false }) treeView;


  @ViewChild('treeviewType', { static: false }) treeviewType: DxTreeViewComponent;
  @ViewChild('treeviewTag', { static: false }) treeviewTag: DxTreeViewComponent;



  @ViewChild('treeBoxType', { static: false }) treeBoxType: DxDropDownBoxComponent;
  @ViewChild('treeBoxTags', { static: false }) treeBoxTags: DxDropDownBoxComponent;


  @ViewChild('listrecomended', { static: false }) listrecomended: DxListComponent;



  @Input() openAI: any;
  @Input() dataSystemSelected: any;
  @Output() closeFirstModal = new EventEmitter<any>();
  @Output() returnImage = new EventEmitter<any>();
  @Output() eliminarFoto = new EventEmitter<any>();
  @Output() importComponentData = new EventEmitter<any>(); 
  @Output() reloadSystem = new EventEmitter<any>(); 
  @Output() importComponents = new EventEmitter<any>(); 

  value: any[] = [];
  imgbase64: any;
  changeimage: boolean;
  modelSystemInformation = {
    systemid: "0",
    area: "",
    systemtype: 0,
    systemname: "",
    controldrawing: "",
    controldwimg: "",
    sort: "",
    qty: "",
    active: false,
    SystemBarName: '',
    MarkLib: false,
    SOP: null,
    DESCRIPTION: '',
    TAGNUM: '',
    TAGTEXT: '',
    SystemTypeid: 0,
    id: 0,
  };

  imgSelected: any = "Not_Image"

  filename: string;
  dataFinalBase64: any = ""


  constructor(
    private systemComponentService: SystemComponentService,
    private MapInformationService: MapInformationService,
    private estimateService: EstimateService,
    private deltaService: DeltaworldService,
    private activatedRouter: ActivatedRoute,
    private utilityService: UtilityService,
    private loadingService: LoadingService,
    private appConfig: AppConfigService,
    private translate: TranslateService,
    private userService: UserService,
    private toast: ToastService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.initForm()
    if (this.dataSystemSelected.base64 != undefined && this.dataSystemSelected.base64 != "") {

      this.MapInformationService.SaveInfoSites({method:"Get_SystemImagePath", systemid:this.dataSystemSelected.systemid})
      .subscribe(resp=>{
        if (resp.length > 0){
          this.MapInformationService.GetDocument(resp[0].ImagePath).subscribe(result => {
            this.imgSelected = result.filestring ? result.filestring : 'Not_Image';

            var data = result.filestring.substring(0, 5);
            let tipo = ""
            switch (data.toUpperCase()) {
              case "IVBOR": tipo = "png";
                break
              case "/9J/4": tipo = "jpeg";
                break
              case "JVBER": tipo = "pdf";
                break
              case "UESDB":
                var data2 = result.filestring.substring(0, 19);
                switch (data.toUpperCase()) {
                  case "UEsDBBQABgAIAAAAIQB": tipo = "xlsx";
                    break
                  default:
                    var data3 = result.filestring.substring(0, 18);
                    switch (data.toUpperCase()) {
                      case "UEsDBBQABgAIAAAAIQ": tipo = "docx";
                        break
                      default: tipo = "zip";
                    }
                }
                break
              case "UMFYI": tipo = "rar";
                break
              case "U1PKC": tipo = "txt";
                break
            }

            this.dataFinalBase64 = "data:image/"+tipo+";base64," + this.imgSelected
            this.imgbase64 = this.imgSelected;
            this.changeimage = true;
          })

        }
      })


      // let data = this.dataSystemSelected.base64.toString().split(",");

      // this.dataFinalBase64 = this.dataSystemSelected.base64.toString()
      // this.imgbase64 = data[0];
      // this.imgSelected = data[0]
      // this.changeimage = true;
    }
  }


  changeFile(ev) {
    if (ev.value.length > 0) {

      this.getBase64(ev.value[0]);
    }
  }

  BorrarDocument() {

    this.imgbase64 = null;
    this.imgSelected = 'Not_Image';
    this.dataFinalBase64 = ""
    this.modelSystemInformation.controldwimg = null
    this.value = []
    this.componentesEncontrados = []

    this.countsystems = 0
    this.dataSystems = []


    delete this.dataSystemSelected.base64

    this.eliminarFoto.emit(this.dataSystemSelected)
  }

  getBase64(file: File) {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      let data = e.target.result.toString().split(",")

      this.dataFinalBase64 = e.target.result.toString()
      this.imgbase64 = data[1];
      this.imgSelected = data[1]
      this.changeimage = true;

    };
    reader.readAsDataURL(file);
  }

  openMultipleSystem: boolean = false
  filterNew: FormGroup

  initForm() {
    this.filterNew = new FormGroup({
      systemid: new FormControl('', []),
      systemtypeID: new FormControl('', []),
      partid: new FormControl('', []),
      verticalmarketid: new FormControl('', []),
      inputappnotes: new FormControl('', []),
      islibrary: new FormControl(true, []),
      projectname: new FormControl('', []),
      systemname: new FormControl('', []),
      projectbidstatusid: new FormControl('', []),
      outputappnotes: new FormControl('', []),
      tagids: new FormControl('', []),
      designerids: new FormControl('', []),
      estimateid: new FormControl('', []),
      componentType: new FormControl('', []),
    })

  }

  componentesEncontrados: any[] = []
  tags:any=""
  tagsNew:any=""

  nameSelected:any[]=[]

  showComponentImageAI() {

    if(this.dataFinalBase64 != ""){

      this.dataSystemSelected.base64 = this.dataFinalBase64

      this.MapInformationService.analyzeImage(this.dataFinalBase64).subscribe({
        next: (response: any = "") => {
          if (response != undefined && response != "") {
            // response += ",MAT"
            // response = "MAT"
            this.tags = response
            this.tagsNew = response
            console.log(this.tags)
            console.log(this.tagsNew)
            this.MapInformationService.SaveInfoSites({ method: "GetComponentsByTag", tagids: response, systemtypeID: this.dataSystemSelected.systemTypeID })
              .subscribe(componets => {
                if (componets.length > 0) {
                  this.componentesEncontrados = componets
                  setTimeout(() => {
                    // this.listrecomended.instance.selectAll()
                    console.log("Aqui 1111")
                    setTimeout(() => {
                      console.log("Aqui 2222")
                      this.componentesEncontrados.forEach(x=>{
                        if (x.ID == undefined){
                          console.log(x)
                          // this.listrecomended.instance.unselectItem(x.DISPLAY_NAME)
                        } else {
                          this.nameSelected.push(x.DISPLAY_NAME)
                          // this.listrecomended.instance.selectItem(x.DISPLAY_NAME)
                        }
                      })
                    }, 1000);
                    console.log(this.componentesEncontrados)
                  }, 500);
                } else {
                  this.componentesEncontrados = []
                }

                // setTimeout(() => {
                //   this.SearchImage()
                // }, 500);
              })
          } else {
            // this.tags = ""
            // this.SearchImage()
          }
        },
        error: (error) => {
          console.error('API Error:', error);
        }
      });
    } else {
      this.toast.warning("You must select or drop a image")
    }


  }

  closeModal() {
    this.closeFirstModal.emit()
  }

  asignarImagen() {
    if (this.dataFinalBase64 != "") {
      this.dataSystemSelected.base64 = this.dataFinalBase64
    }
    this.returnImage.emit(this.dataSystemSelected)
  }


  closeParentsSystemType() {
    this.treeviewTag.instance.collapseAll()
  }

  OpenParentsSystemType() {
    this.treeviewTag.instance.expandAll()
  }


  closeParentsComponentType() {
    this.treeviewType.instance.collapseAll()
  }

  OpenParentsComponentType() {
    this.treeviewType.instance.expandAll()
  }


  treeBoxValue0: string[] = [];

  syncTreeViewSelection0(e) {
    var component =
      (e && e.component) || (this.treeviewType && this.treeviewType.instance);

    if (!component) return;

    if (!this.treeBoxValue0) {
      component.unselectAll();
    }

    if (this.treeBoxValue0) {
      this.treeBoxValue0.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }

    // setTimeout(() => {
    //   this.treeviewType.instance.expandAll()
    // }, 500);

  }

  categorySelected: any[] = []
  treeBoxValue: string[];

  treeView_itemSelectionChanged0(e) {
    if (e.itemElement != undefined) {

      this.treeBoxValue0 = e.component.getSelectedNodeKeys();

      if (this.treeBoxValue0.length > 0) {
        this.categorySelected = e.itemData.ID
        this.filterNew.get("componentType").setValue(this.treeBoxValue0)
      } else {
        this.categorySelected = []
        this.treeBoxValue0 = []
        this.treeBoxValue = []

        if (this.treeBoxType != undefined) {
          this.treeBoxType.instance.reset()
        }

        if (this.treeviewType != undefined) {
          this.treeviewType.instance.unselectAll()
        }
        this.filterNew.get("componentType").setValue("")
      }
    }
  }


  typeids: any[] = []
  syncTreeViewSelection2(e) {
    var component =
      (e && e.component) || (this.treeviewTag && this.treeviewTag.instance);

    if (!component) return;

    if (!this.treeBoxValue2) {
      component.unselectAll();
    }

    if (this.treeBoxValue2) {
      this.treeBoxValue2.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }

    // setTimeout(() => {
    //   this.treeviewTag.instance.expandAll()
    // }, 500);
  }

  treeBoxValue2: string[] = [];
  notAllowed: boolean = false
  FirtsTime: boolean = true

  treeView_itemSelectionChanged2(e) {
    if (e.itemElement != undefined && this.notAllowed == false) {
      // 
      this.treeBoxValue2 = e.component.getSelectedNodeKeys();

      this.typeids = e.itemData.ID
      this.filterNew.get("systemtypeID").setValue(this.treeBoxValue2)
    } else {
      this.notAllowed = false
    }


    if (e.itemElement != undefined) {
      const ids = e.component.getSelectedNodeKeys()
      if (ids.length > 0) {
        this.treeBoxValue2 = e.component.getSelectedNodeKeys();
        this.typeids = e.itemData.ID
        this.filterNew.get("systemtypeID").setValue(this.treeBoxValue2)
        this.FirtsTime = false
      } else {
        this.typeids = []
        this.treeBoxValue2 = []
        if (this.treeBoxTags != undefined) {
          this.treeBoxTags.instance.reset()
        }

        if (this.treeviewTag != undefined) {
          this.treeviewTag.instance.unselectAll()
        }

        this.filterNew.get("systemtypeID").setValue("")
      }
    }
  }

  groupItemsFilter: any[] = []
  typeDatasource: any[] = []

  openFilterParents() {
    this.estimateService.Get_EstimateLibComponentsTreeCE2().subscribe(result => {
      this.groupItemsFilter = result
    });
    this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
      this.typeDatasource = result;
    });
  }


  clearFilterIndividual(typeOfClear) {
    switch (typeOfClear) {
      case 'System Type':
        this.typeids = []
        this.treeBoxValue2 = []
        if (this.treeBoxTags != undefined) {
          this.treeBoxTags.instance.reset()
        }

        if (this.treeviewTag != undefined) {
          this.treeviewTag.instance.unselectAll()
        }

        this.filterNew.get("systemtypeID").setValue("")

        break
      case 'Component Type':

        this.categorySelected = []
        this.treeBoxValue = []

        if (this.treeBoxType != undefined) {
          this.treeBoxType.instance.reset()
        }

        if (this.treeviewType != undefined) {
          this.treeviewType.instance.unselectAll()
        }
        this.filterNew.get("componentType").setValue("")
        break
      case 'Estimate ID':
        this.searchEstimate.instance.reset()
        this.filterNew.get("estimateid").setValue("")
        this.searchEstimate.placeholder = ""

        break
    }
    this.SearchImage()
    console.log("1")
  }


  base64Imagenes: any[] = []
  dataSystems: any[] = []
  SearchImage(loadImages:boolean = false) {

    let settings: any = localStorage.getItem('settings');
    if (settings && settings != 'null') {
      settings = JSON.parse(settings);
      if (settings.estimateidDefault) {
        let infoFilter = this.filterNew.value
        // let data = {
        //   method: "Get_AreaSystemAllCE2NyComponentsIdsWithouParent", //Get_AreaSystemAllCE2NyComponentsIds    || Get_AreaSystemAllCE2
        //   systemids: infoFilter.systemid,
        //   systemtypeids: infoFilter.systemtypeID != "" ? infoFilter.systemtypeID.join(",") : "",
        //   componentids: infoFilter.componentType != "" ? infoFilter.componentType.join(",") : "",
        //   estimateid: infoFilter.estimateid,
        //   islibrary: infoFilter.islibrary == "Yes" ? 1 : infoFilter.islibrary
        // }

        let data = {
          method: "GetSimilarSystemByTags", //Get_AreaSystemAllCE2NyComponentsIds    || Get_AreaSystemAllCE2
          systemtype: this.dataSystemSelected.systemTypeID,
          componentids: "",
          tags: this.tagsNew,
          islibrary: infoFilter.islibrary == "Yes" || infoFilter.islibrary == true ? 1 : infoFilter.islibrary,
          similarity_type:"fuzzy" //normal y fuzzy
        }

        console.log(data)
        console.log(this.tags)
        console.log(this.tagsNew)

        // this.estimateService.GetSystemArea(settings.estimateidDefault).subscribe((result) => {
        this.MapInformationService.SaveInfoSites2(data).subscribe((result) => {
          if (result.length > 0){
            if (result[0].response != ""){
              const array = JSON.parse(result[0].response);
              this.countsystems = array.length
              this.dataSystems = array
              if(loadImages){
                this.importComponent()
              }
            } else {
            }
          } else {
            this.countsystems = 0
            this.dataSystems = []
            this.toast.warning("There are no systems with the components found")

          }
        })

      }
    }
  }

  countsystems: any = 0


  importComponent() {
    this.openFilterParents()
    this.openMultipleSystem = true
    if (this.dataSystems.length > 0) {
      this.getbase64Info()
      this.showImages = true
    } else {
      this.showImages = false
    }
  }

  showImages: boolean = false
  getbase64Info() {
    this.base64Imagenes = []
    let contador = 0
    console.log(this.dataSystems)
    for (let i = 0; i < this.dataSystems.length; i++) {
      this.MapInformationService.GetDocumentThumImg(this.dataSystems[i].imagepath).subscribe(result => {
        let tipo
        var data = result.filestring.substring(0, 5);
        switch (data.toUpperCase()) {
          case "/9J/4": tipo = "jpeg";
            break
          default:
            tipo = "png"
            break
        }
        let informacion = {
          tipo: tipo,
          base64: result.filestring,
          info: this.dataSystems[i],
          // Sort: this.dataSystems[i].Sort,
          selected:false
        }
        this.base64Imagenes.push(informacion)
        contador++
        if (contador == this.base64Imagenes.length) {
          this.base64Imagenes.sort(function (a, b) { return a.Sort - b.Sort; })
        }
      }, error => {
      })
    }
  }


  onSelectionChanged(data) {
    console.log(data)
    if (this.listrecomended.selectedItems.length > 0) {
      this.categorySelected = this.listrecomended.selectedItems.map(x => Number(x.ID))

      this.nameSelected = this.listrecomended.selectedItems.map(x => Number(x.ID))

      this.filterNew.get("componentType").setValue(this.categorySelected)
      // this.SearchImage()
      console.log("2")
    } else {
      this.categorySelected = []
      this.filterNew.get("componentType").setValue([])
      // this.SearchImage()
      console.log("3")
    }
  }


  selectItem(event, data){
    let dataTempo
    // if (event.value){
      dataTempo = this.base64Imagenes.map(x=>{
        if (x.info.systemid == data.info.systemid){
          x.selected = event.value
        } else {
          x.selected = !event.value
        }
        return x
      })
    // } else {
      // dataTempo = this.base64Imagenes.map(x=>{
      //   x.selected = false
      //   return x
      // })
    // }

    this.base64Imagenes = dataTempo

  }


  BuscarImagen(e){
    setTimeout(() => {
      this.SearchImage()
      console.log("4")
    }, 500);
  }


  ImportSystem(){
    const systemSelected = this.base64Imagenes.filter(x=>x.selected)[0].info.systemid
    

    this.dataSystemSelected.sytemOrigin = systemSelected


    this.importComponentData.emit(this.dataSystemSelected)
    this.closeFirstModal.emit()

  }

  importComponentsInfo(){


    if(this.dataFinalBase64 != ""){
      const idsComponents =  this.listrecomended.selectedItems.map(x => Number(x.ID))
      this.dataSystemSelected.idsComponents = idsComponents
      this.importComponents.emit(this.dataSystemSelected)

    } else {
      this.toast.warning("You must select or drop a image")
    }

  }

  imagenFullScreen:any=""
  tipoimagen:any=""
  openModalFullScreen:boolean = false

  Openimage(base64, tipo, info) {
    this.imagenFullScreen = base64;
    this.openModalFullScreen = true;
    this.tipoimagen = tipo;
  }


  importComponentsDirect(){
    console.log(this.listrecomended.selectedItems)
    console.log("Aquiii")

    let data = this.listrecomended.selectedItems

    let uniqueItemsData = this.getUniqueItems(data)

    console.log(uniqueItemsData)

    let stringComponent = ""
    let contador = 0
    uniqueItemsData.forEach(x => {
      if(x.ID == undefined){
        contador++
      } else {
        contador++
        if (stringComponent == "") {
          stringComponent += x.ID + "/" + contador * -1
        } else {
          stringComponent += "," + x.ID + "/" + contador * -1
        }
      }
    })

    console.log(this.dataSystemSelected)
    const info = {
      "method": "insert_EstimateRevisionAreaSystemDetail2",
      "systemid": this.dataSystemSelected.systemid + "-1",
      "componentids": stringComponent
    }

    console.log(info)

    

    this.MapInformationService.SaveInfoSites(info)
    .subscribe(resp=>{
      this.closeModal()
      this.dataSystemSelected.sytemOrigin = this.dataSystemSelected.systemid
      this.closeFirstModal.emit()
      this.reloadSystem.emit()
      this.toast.success("Build Successfully")
    })

 
  }


  getUniqueItems(arr) {
    const uniqueMap = new Map();
    arr.forEach(item => {
        if (!uniqueMap.has(item.ID)) {
            uniqueMap.set(item.ID, item);
        }
    });
    return Array.from(uniqueMap.values());
}


}
